import React from 'react'
import './AboutUsPage.css'

function AboutUsPage() {
  return (
    <div className="about-page">
      <div className="about-hero">
        <div className="container">
          <h1>About MoRecharz</h1>
          <p>Transforming Mobile Recharges in India</p>
        </div>
      </div>

      <div className="container">
        <div className="about-content">
          <section className="about-section">
            <h2>Who We Are</h2>
            <p>
              MoRecharz is a leading mobile recharge platform dedicated to providing fast, secure, and convenient recharge services to millions of users across India. We believe in simplifying the way you manage your mobile connectivity.
            </p>
          </section>

          <section className="about-section">
            <h2>Our Mission</h2>
            <p>
              To revolutionize the mobile recharge experience by providing a seamless, user-friendly platform that puts customers first. We're committed to making mobile recharges quick, affordable, and hassle-free for everyone.
            </p>
          </section>

          <section className="about-section">
            <h2>Why Choose Us?</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">
                  <span className="material-icons">flash_on</span>
                </div>
                <h3>Instant Recharge</h3>
                <p>Get your recharge processed instantly with real-time status updates</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <span className="material-icons">lock</span>
                </div>
                <h3>Secure & Safe</h3>
                <p>Industry-leading encryption ensures your data is always protected</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <span className="material-icons">public</span>
                </div>
                <h3>All Operators</h3>
                <p>Support for all major telecom operators across India</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <span className="material-icons">card_giftcard</span>
                </div>
                <h3>Best Offers</h3>
                <p>Exclusive deals and cashback offers on every recharge</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <span className="material-icons">support_agent</span>
                </div>
                <h3>24/7 Support</h3>
                <p>Round-the-clock customer support for all your queries</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <span className="material-icons">verified</span>
                </div>
                <h3>No Hidden Charges</h3>
                <p>Transparent pricing with zero hidden fees</p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2>Our Values</h2>
            <div className="values-list">
              <div className="value-item">
                <h3>Transparency</h3>
                <p>We believe in complete transparency in all our transactions and dealings</p>
              </div>
              <div className="value-item">
                <h3>Reliability</h3>
                <p>Your trust is our most valued asset, and we work tirelessly to maintain it</p>
              </div>
              <div className="value-item">
                <h3>Innovation</h3>
                <p>Continuously improving our platform to deliver the best user experience</p>
              </div>
              <div className="value-item">
                <h3>Customer Focus</h3>
                <p>Every decision we make is centered around our customers' needs</p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2>Get in Touch</h2>
            <div className="contact-info">
              <p><strong>WhatsApp:</strong> <a href="https://wa.me/917655062254" target="_blank" rel="noopener noreferrer">+91 76550 62254</a></p>
              <p><strong>Email:</strong> <a href="mailto:support@morecharz.com">support@morecharz.com</a></p>
              <p><strong>Hours:</strong> 24/7 Available</p>
              <p><strong>Address:</strong> MoRecharz (OPC) Private Limited, Patuli, Olaver, Kendrapada, Odisha, 754227, India</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}

export default AboutUsPage
